// extracted by mini-css-extract-plugin
module.exports = {"icon":"SvgIcon_icon__NJnGz","fill":"SvgIcon_fill__LHngU","stroke":"SvgIcon_stroke__Qz4Tr"};